import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens';
import { EnvConfig } from '@shared/definitions';

import { CookieConsentService } from './cookie-consent.service';

@Injectable({
  providedIn: 'root',
})
export class ClarityService {
  private initialized = false;

  constructor(@Inject(ENV_CONFIG) private config: EnvConfig, private cookieConsentService: CookieConsentService) {}

  init(): void {
    // Wait for consent before initializing
    this.cookieConsentService.consent$.subscribe((consent) => {
      if (/* consent?.analytics && */ !this.initialized && this.config.clarityId) {
        this.loadClarity();
        this.initialized = true;
      }
    });
  }

  private loadClarity(): void {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
(function (c, l, a, r, i, t, y) {
  c[a] =
    c[a] ||
    function () {
      (c[a].q = c[a].q || []).push(arguments);
    };
  t = l.createElement(r);
  t.async = 1;
  t.src = 'https://www.clarity.ms/tag/' + i;
  y = l.getElementsByTagName(r)[0];
  y.parentNode.insertBefore(t, y);
})(window, document, 'clarity', 'script', '${this.config.clarityId}');
`;
    document.head.appendChild(script);
  }

  set(key: string, value: string): void {
    (window as any)?.clarity?.('set', key, value);
  }

  event(name: string): void {
    (window as any)?.clarity?.('event', name);
  }
}
